export const NETWORK = {
  name: process.env.CHAIN_NETWORK,
  chainId: +(process.env.CHAIN_ID || 31337),
  blockExplorer: process.env.CHAIN_BLOCK_EXPLORER,
  color: process.env.CHAIN_COLOR || "#ff0000",
  rpcUrl: process.env.CHAIN_URL,
}
